import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getCorporate } from "../../../Services/adminCorporates";

/**
 * Shared context for the corporate detail layout. Each tab can `useCorporate()`
 * to read the loaded corporate or trigger a `refetch()` after a mutation.
 */
const CorporateContext = createContext({
  corporate: null,
  loading: true,
  error: null,
  refetch: () => {},
});

export const CorporateProvider = ({ id, children }) => {
  const [corporate, setCorporate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getCorporate(id);
      setCorporate(data);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "Failed to load enterprise");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <CorporateContext.Provider value={{ corporate, loading, error, refetch }}>
      {children}
    </CorporateContext.Provider>
  );
};

export const useCorporate = () => useContext(CorporateContext);
